import { render, staticRenderFns } from "./correctTopProdInfo.vue?vue&type=template&id=22883222&scoped=true&"
import script from "./correctTopProdInfo.vue?vue&type=script&lang=js&"
export * from "./correctTopProdInfo.vue?vue&type=script&lang=js&"
import style0 from "./correctTopProdInfo.vue?vue&type=style&index=0&id=22883222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22883222",
  null
  
)

export default component.exports